import {
  createOrder,
  getUserOrders,
  getOrderById,
} from "./asyncThunks";

export const createOrderBuilder = (builder) => {
  builder
    .addCase(createOrder.pending, (state) => {
      state.orderLoading = true;
      state.error = null;
    })
    .addCase(createOrder.fulfilled, (state, { payload }) => {
      state.orderLoading = false;
      state.currentOrder = payload.order;
    })
    .addCase(createOrder.rejected, (state, { payload }) => {
      state.orderLoading = false;
      state.error = payload;
    });
};

export const getUserOrdersBuilder = (builder) => {
  builder
    .addCase(getUserOrders.pending, (state) => {
      state.ordersLoading = true;
      state.error = null;
    })
    .addCase(getUserOrders.fulfilled, (state, { payload }) => {
      state.ordersLoading = false;
      state.orders = payload.orders;
    })
    .addCase(getUserOrders.rejected, (state, { payload }) => {
      state.ordersLoading = false;
      state.error = payload;
    });
};

export const getOrderByIdBuilder = (builder) => {
  builder
    .addCase(getOrderById.pending, (state) => {
      state.selectedOrderLoading = true;
      state.error = null;
    })
    .addCase(getOrderById.fulfilled, (state, { payload }) => {
      state.selectedOrderLoading = false;
      state.selectedOrder = payload.order;
    })
    .addCase(getOrderById.rejected, (state, { payload }) => {
      state.selectedOrderLoading = false;
      state.error = payload;
    });
};